<template>
  <div>
    <section class="section-quickbook d-none d-md-block">
      <!-- DESKTOP -->
      <div class="row">
        <div class="col-12 mb-2">
          <!-- <label class="d-none d-lg-block">QUICK BOOKINGS</label> -->

          <div class="d-flex align-items-center qb-heading">
            <div
              class="bg-rose-gold py-2 px-2 mr-4 rounded qb-title"
            >
              QUICK BOOKINGS
            </div>
            <div
              class="qb-movie"
              @click="qbFilterTab('byMovie')"
              :class="byMovie == true ? 'active' : ''"
            >
              By Movie
            </div>
            <div class="mx-2">|</div>
            <div
              class="qb-cinema"
              @click="qbFilterTab('byCinema')"
              :class="byCinema == true ? 'active' : ''"
            >
              By Cinema
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row" v-if="byMovie">
            <!-- LEFT SECTION -->
            <div class="col-md-6">
              <div class="row">
                <div class="col-lg-6 mb-3 mb-lg-0">
                  <div
                    class="has-chevron"
                    :class="qbSelectMovieContent ? 'chevron-inverse' : ''"
                    @click="qbSelectMovieContent = !qbSelectMovieContent"
                  >
                    <input
                      ref="selectedMovie"
                      type="text"
                      class="form-control"
                      placeholder="Select Movie"
                      v-model="qbSelectedMovie"
                    />
                  </div>
                  <div
                    class="quickbook-select-movie-content"
                    v-if="qbSelectMovieContent"
                  >
                    <ul
                      class="list-unstyled qb-li-padding"
                      v-for="(movieListingQb, movieListingQbKey) in movies"
                      :key="movieListingQbKey"
                    >
                      <li class="p-2">
                        <div class="text-rose-gold">
                          {{ movieListingQb.Languages[0].language_name }}
                        </div>
                      </li>
                      <li v-for="(c, d) in movieListingQb.Languages" :key="d">
                        <router-link
                          class="d-block"
                          @focus.native="handleMovieSelect(c.Film_strTitle)"
                          to
                          >{{ c.Film_strTitle }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-6 mb-3 mb-lg-0">
                  <div class="connector"></div>
                  <div
                    class="has-chevron"
                    :class="qbSelectCinemaContent ? 'chevron-inverse' : ''"
                    @click="
                        movie_title
                          ? (qbSelectCinemaContent = !qbSelectCinemaContent)
                          : null
                      "
                  >
                    <input
                      ref="selectedCinema"
                      type="text"
                      class="form-control"
                      placeholder="Select Cinema"
                      v-model="qbSelectedCinemas"
                    />
                  </div>

                  <div
                    class="quickbook-select-cinema-content"
                    v-if="qbSelectCinemaContent"
                  >
                    <ul class="list-unstyled qb-li-padding">
                      <!-- <div class="text-rose-gold">Near You</div> -->
                      <li
                        v-for="(cinemasLoop, cinemasLoopKey) in cinemas"
                        :key="cinemasLoopKey"
                      >
                        <router-link
                          class="d-block"
                          @focus.native="
                            handleCinemaSelect(
                              cinemasLoop.Cinema_strID,
                              cinemasLoop.Cinema_strName
                            )
                          "
                          to
                          >{{ cinemasLoop.Cinema_strName }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- RIGHT SECTION -->
            <div class="col-md-6">
              <div class="row">
                <div class="col-lg col-xl mb-3 mb-lg-0">
                  <div class="connector"></div>
                  <div
                    class="has-chevron"
                    :class="qbSelectDateContent ? 'chevron-inverse' : ''"
                    @click="
                        cinema_code
                          ? (qbSelectDateContent = !qbSelectDateContent)
                          : null
                      "
                  >
                    <input
                      ref="SelectedDate"
                      type="text"
                      class="form-control"
                      placeholder="Select Date"
                      :value="qbSelectedDate | daywithdayparse"
                      @input="(value) => (qbSelectedDate = value)"
                    />
                  </div>

                  <div
                    class="quickbook-select-date-content"
                    v-if="qbSelectDateContent"
                  >
                    <ul class="list-unstyled qb-li-padding mb-0">
                      <li
                        v-for="(qbDate, qbDateLoop) in dates"
                        :key="qbDateLoop"
                      >
                        <router-link
                          class="d-block"
                          @focus.native="handleDateSelect(qbDate)"
                          to
                        >
                          {{ qbDate | daywithdayparse }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg col-xl mb-3 mb-lg-0">
                  <div class="connector"></div>
                  <div class="has-chevron"
                    @click="
                          date
                            ? (qbSelectShowTimeContent = !qbSelectShowTimeContent)
                            : null
                        "
                  >
                    <input
                      ref="SelectedShowTime"
                      type="text"
                      class="form-control"
                      placeholder="Select Timing"
                      :value="qbSelectedShowTime | timeparse"
                      @input="(value) => (qbSelectedShowTime = value)"
                    />
                  </div>
                  <div
                    class="quickbook-select-showtime-content"
                    v-if="qbSelectShowTimeContent"
                  >
                    <!-- @mouseleave="
                  date
                    ? (qbSelectShowTimeContent = !qbSelectShowTimeContent)
                    : null
                "-->
                    <ul class="list-unstyled qb-li-padding mb-0">
                      <li
                        v-for="(qbDate, qbDateLoop) in shows"
                        :key="qbDateLoop"
                      >
                        <router-link
                          class="d-block"
                          @focus.native="
                            handleShowSelect(
                              qbDate.Session_dtmRealShow,
                              qbDate.Session_lngSessionId
                            )
                          "
                          to
                          >{{
                            qbDate.Session_dtmRealShow | timeparse
                          }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-3 d-none d-lg-block">
                  <button
                    @click="
                      $router.push({
                        name: 'Seat Layout',
                        params: { session_id: session, cinema_code },
                      })
                    "
                    class="btn btn-primary w-100"
                  >
                    Book
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="byCinema">
            <!-- LEFT SECTION -->
            <div class="col-md-6">
              <div class="row">
                <div class="col-lg-6 mb-3 mb-lg-0">
                  <div
                    class="has-chevron"
                    :class="qbSelectCinemaContent ? 'chevron-inverse' : ''"
                    @click="qbSelectCinemaContent = !qbSelectCinemaContent"
                  >
                    <input
                      ref="selectedCinema"
                      type="text"
                      class="form-control"
                      placeholder="Select Cinema"
                      v-model="qbSelectedCinemas"
                    />
                  </div>
                  <div
                    class="quickbook-select-cinema-content"
                    v-if="qbSelectCinemaContent"
                  >
                    <ul class="list-unstyled qb-li-padding">
                      <div class="text-rose-gold pt-2 px-2">Near You</div>
                      <li
                        v-for="(cinemasLoop, cinemasLoopKey) in cinemas"
                        :key="cinemasLoopKey"
                      >
                        <router-link
                          class="d-block"
                          @focus.native="
                            handleCinemaSelect(
                              cinemasLoop.Cinema_strID,
                              cinemasLoop.Cinema_strName
                            )
                          "
                          to
                          >{{ cinemasLoop.Cinema_strName }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg-6 mb-3 mb-lg-0">
                  <div class="connector"></div>
                  <div
                    class="has-chevron"
                    :class="qbSelectMovieContent ? 'chevron-inverse' : ''"
                    @click="
                        cinema_code
                          ? (qbSelectMovieContent = !qbSelectMovieContent)
                          : null
                      "
                  >
                    <input
                      ref="selectedMovie"
                      type="text"
                      class="form-control"
                      placeholder="Select Movie"
                      v-model="qbSelectedMovie"
                    />
                  </div>
                  <div
                    class="quickbook-select-movie-content"
                    v-if="qbSelectMovieContent"
                  >
                    <ul
                      class="list-unstyled qb-li-padding"
                      v-for="(movieListingQb, movieListingQbKey) in movies"
                      :key="movieListingQbKey"
                    >
                      <li class="p-2">
                        <div class="text-rose-gold">
                          {{ movieListingQb.Languages[0].language_name }}
                        </div>
                      </li>
                      <li v-for="(c, d) in movieListingQb.Languages" :key="d">
                        <router-link
                          class="d-block"
                          @focus.native="handleMovieSelect(c.Film_strTitle)"
                          to
                          >{{ c.Film_strTitle }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- RIGHT SECTION -->
            <div class="col-md-6">
              <div class="row">
                <div class="col-lg col-xl mb-3 mb-lg-0">
                  <div class="connector"></div>
                  <div
                    class="has-chevron"
                    :class="qbSelectDateContent ? 'chevron-inverse' : ''"
                    @click="
                        movie_title
                          ? (qbSelectDateContent = !qbSelectDateContent)
                          : null
                      "
                  >
                    <input
                      ref="SelectedDate"
                      type="text"
                      class="form-control"
                      placeholder="Select Date"
                      :value="qbSelectedDate | daywithdayparse"
                      @input="(value) => (qbSelectedDate = value)"
                    />
                  </div>

                  <div
                    class="quickbook-select-date-content"
                    v-if="qbSelectDateContent"
                  >
                    <ul class="list-unstyled qb-li-padding mb-0">
                      <li
                        v-for="(qbDate, qbDateLoop) in dates"
                        :key="qbDateLoop"
                      >
                        <router-link
                          class="d-block"
                          @focus.native="handleDateSelect(qbDate)"
                          to
                        >
                          {{ qbDate | daywithdayparse }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-lg col-xl mb-3 mb-lg-0">
                  <div class="connector"></div>
                  <div class="has-chevron"
                    @click="
                          date
                            ? (qbSelectShowTimeContent = !qbSelectShowTimeContent)
                            : null
                        "
                  >
                    <input
                      ref="SelectedShowTime"
                      type="text"
                      class="form-control"
                      placeholder="Select Timing"
                      :value="qbSelectedShowTime | timeparse"
                      @input="(value) => (qbSelectedShowTime = value)"
                    />
                  </div>
                  <div
                    class="quickbook-select-showtime-content"
                    v-if="qbSelectShowTimeContent"
                  >
                    <!-- @mouseleave="
                  date
                    ? (qbSelectShowTimeContent = !qbSelectShowTimeContent)
                    : null
                "-->
                    <ul class="list-unstyled qb-li-padding mb-0">
                      <li
                        v-for="(qbDate, qbDateLoop) in shows"
                        :key="qbDateLoop"
                      >
                        <router-link
                          class="d-block"
                          @focus.native="
                            handleShowSelect(
                              qbDate.Session_dtmRealShow,
                              qbDate.Session_lngSessionId
                            )
                          "
                          to
                          >{{
                            qbDate.Session_dtmRealShow | timeparse
                          }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-3 d-none d-lg-block">
                  <button
                    @click="
                      $router.push({
                        name: 'Seat Layout',
                        params: { session_id: session, cinema_code },
                      })
                    "
                    class="btn btn-primary w-100"
                  >
                    Book
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 mx-auto text-center d-lg-none">
          <button class="btn btn-primary w-100">Book</button>
        </div>
      </div>
    </section>

    <!-- MOBILE -->
    <section class="d-md-none">
      <!-- MOBILE QUICK BOOKING FOOTER -->
      <div
        class="mobile-footer"
        @click="showQuickBookSection"
        v-if="QuickBookSection == false"
      >
        Quick Booking
        <img src="@/assets/img/icons/up-arrow-icon.svg" class="ml-2" alt />
      </div>

      <!-- USE 'disabled' CLASS TO DISABLED FOOTER -->
      <div
        class="mobile-footer"
        v-if="QuickBookSection"
        @click="
          $router.push({
            name: 'Seat Layout',
            params: { session_id: session, cinema_code },
          })
        "
      >
        Book
      </div>

      <!-- MOBILE QUICK BOOKING POPUP -->
      <div class="mobile-Box" v-if="QuickBookSection">
        <div class="p-3 mobile-header">
          Quick Booking
          <span class="float-right" @click="closeQuickBookSection">
            <img src="@/assets/img/icons/close-white-icon.svg" alt />
          </span>
        </div>

        <div class="qb-body px-4 w-100">
          <div class="section-space-50"></div>
          <div class="section-space-50"></div>
          <div>
            <div class="d-flex align-items-center mb-3">
              <div
                class="w-50 qb-movie mr-1"
                @click="qbFilterTab('byMovie')"
                :class="byMovie == true ? 'active' : ''"
              >
                By Movie
              </div>
              <div
                class="w-50 qb-cinema ml-1"
                @click="qbFilterTab('byCinema')"
                :class="byCinema == true ? 'active' : ''"
              >
                By Cinema
              </div>
            </div>
            <!-- BY MOVIE TAB START -->
            <div v-if="byMovie">
              <!-- SELECT MOVIE -->
              <div class="position-relative mb-2">
                <form>
                  <div
                    class="has-chevron"
                    :class="selectMovie ? 'chevron-inverse' : ''"
                  >
                    <!-- <input
                    type="search"
                    placeholder="Select Movie"
                    v-model="selectedMovie"
                    @mouseenter="selectMovie = !selectMovie"
                    class="form-control"
                  /> -->

                    <div
                      @click="isSelected('movieSelected')"
                      class="text-muted qb-mobile-tab"
                    >
                      {{ selectedMovie || "Select Movie" }}
                    </div>
                  </div>
                </form>

                <div
                  class="select-location-box w-100 mobile-Quick-book-input py-2"
                  v-if="selectMovie"
                 
                >
                  <div class="mb-2" v-for="(a, b) in movies" :key="b">
                    <p class="px-3 mb-0 lang">
                      {{ a.Languages[0].language_name }}
                    </p>
                    <ul class="search-result-list list-unstyle mb-0">
                      <li
                        class="cursor-pointer list-item"
                        v-for="(c, d) in a.Languages"
                        :key="d"
                      >
                        <router-link
                          class="w-100 h-100 d-block"
                          to
                          @click.native="handleMovieSelect(c.Film_strTitle)"
                          >{{ c.Film_strTitle }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- SELECT CINEMA -->
              <div class="position-relative mb-2">
                <form>
                  <div
                    class="has-chevron"
                    :class="selectCinema ? 'chevron-inverse' : ''"
                  >
                    <!-- <input
                    type="search"
                    placeholder="Select Cinema"
                    v-model="selectedCinema"
                    @mouseenter="selectCinema = !selectCinema"
                    class="form-control"
                  /> -->
                    <div
                      @click="isSelected('cinemaSelected')"
                      class="text-muted qb-mobile-tab"
                    >
                      {{ selectedCinema || "Select Cinema" }}
                    </div>
                  </div>
                </form>

                <div
                  class="select-location-box w-100 mobile-Quick-book-input py-2"
                  v-if="selectCinema"
                 
                >
                  <div class="">
                    <!-- <p class="px-3 mb-0 lang">Hindi</p> -->
                    <ul class="search-result-list list-unstyle">
                      <li
                        class="cursor-pointer list-item"
                        v-for="(a, b) in cinemas"
                        :key="b"
                      >
                        <router-link
                          class="w-100 h-100 d-block"
                          to
                          @click.native="
                            handleCinemaSelect(a.Cinema_strID, a.Cinema_strName)
                          "
                          >{{ a.Cinema_strName }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- BY MOVIE TAB END -->

            <!-- BY CINEMA TAB START -->
            <div v-if="byCinema">
              <!-- SELECT CINEMA -->
              <div class="position-relative mb-2">
                <form>
                  <div
                    class="has-chevron"
                    :class="selectCinema ? 'chevron-inverse' : ''"
                  >
                    <!-- <input
                    type="search"
                    placeholder="Select Cinema"
                    v-model="selectedCinema"
                    @mouseenter="selectCinema = !selectCinema"
                    class="form-control"
                  /> -->
                    <div
                      @click="isSelected('cinemaSelected')"
                      class="text-muted qb-mobile-tab"
                    >
                      {{ selectedCinema || "Select Cinema" }}
                    </div>
                  </div>
                </form>

                <div
                  class="select-location-box w-100 mobile-Quick-book-input py-2"
                  v-if="selectCinema"
                  
                >
                  <div class="">
                    <ul class="search-result-list list-unstyle">
                      <li
                        class="cursor-pointer list-item"
                        v-for="(cinemasLoop, cinemasLoopKey) in cinemas"
                        :key="cinemasLoopKey"
                      >
                        <router-link
                          to
                          class="w-100 h-100 d-block"
                          @click.native="
                            handleCinemaSelect(
                              cinemasLoop.Cinema_strID,
                              cinemasLoop.Cinema_strName
                            )
                          "
                          >{{ cinemasLoop.Cinema_strName }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- SELECT MOVIE -->
              <div class="position-relative mb-2">
                <form>
                  <div
                    class="has-chevron"
                    :class="selectMovie ? 'chevron-inverse' : ''"
                  >

                    <div
                      @click="isSelected('movieSelected')"
                      class="text-muted qb-mobile-tab"
                    >
                      {{ selectedMovie || "Select Movie" }}
                    </div>
                  </div>
                </form>

                <div
                  class="select-location-box w-100 mobile-Quick-book-input py-2"
                  v-if="selectMovie"
                 
                >
                  <div class="mb-2" v-for="(a, b) in movies" :key="b">
                    <p class="px-3 mb-0 lang">
                      {{ a.Languages[0].language_name }}
                    </p>
                    <ul class="search-result-list list-unstyle mb-0">
                      <li
                        class="cursor-pointer list-item"
                        v-for="(c, d) in a.Languages"
                        :key="d"
                      >
                        <router-link
                          to
                          class="w-100 h-100 d-block"
                          @click.native="handleMovieSelect(c.Film_strTitle)"
                          >{{ c.Film_strTitle }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- BY CINEMA TAB END -->

            <!-- SELECT DATE -->
            <div class="position-relative mb-2">
              <form>
                <div
                  class="has-chevron"
                  :class="selectDate ? 'chevron-inverse' : ''"
                >
                  <!-- <input
                    type="search"
                    placeholder="Select Date"
                    :value="selectedDate | daywithdayparse"
                    @input="(value) => (selectedDate = value)"
                    @mouseenter="selectDate = !selectDate"
                    class="form-control"
                  /> -->
                  <div
                    @click="isSelected('dateSelected')"
                    class="text-muted qb-mobile-tab"
                  >
                    <span v-if="selectedDate">
                      {{ selectedDate | daywithdayparse }}
                    </span>
                    <span v-else> Select Date </span>
                  </div>
                </div>
              </form>

              <div
                class="select-location-box w-100 mobile-Quick-book-input py-2"
                v-if="selectDate"
              >
                <div class="">
                  <!-- <p class="px-3 mb-0 lang">Hindi</p> -->
                  <ul class="search-result-list list-unstyle">
                    <li
                      class="cursor-pointer list-item"
                      v-for="(a, b) in dates"
                      :key="b"
                    >
                      <router-link
                        class="w-100 h-100 d-block"
                        to
                        @click.native="handleDateSelect(a)"
                        >{{ a | daywithdayparse }}</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- SELECT TIMING -->
            <div class="position-relative mb-2">
              <form>
                <div
                  class="has-chevron"
                  :class="selectTime ? 'chevron-inverse' : ''"
                >
                  <!-- <input
                    type="search"
                    placeholder="Select Timing"
                    :value="selectedTime | timeparse"
                    @mouseenter="selectTime = !selectTime"
                    class="form-control"
                  /> -->
                  <div
                    @click="isSelected('timeSelected')"
                    class="text-muted qb-mobile-tab"
                  >
                    <span v-if="selectedTime">
                      {{ selectedTime | timeparse }}
                    </span>
                    <span v-else> Select Time </span>
                  </div>
                </div>
              </form>

              <div
                class="select-location-box w-100 mobile-Quick-book-input py-2"
                v-if="selectTime"
              >
                <div class="">
                  <!-- <p class="px-3 mb-0 lang">Hindi</p> -->
                  <ul class="search-result-list list-unstyle">
                    <li
                      class="cursor-pointer list-item"
                      v-for="(a, b) in shows"
                      :key="b"
                    >
                      <router-link
                        class="w-100 h-100 d-block"
                        @click.native="
                          handleShowSelect(
                            a.Session_dtmRealShow,
                            a.Session_lngSessionId
                          )
                        "
                        to
                        >{{ a.Session_dtmRealShow | timeparse }}</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="section-space-50"></div>
          <div class="section-space-50"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import QuickBookService from "@/apiServices/QuickBookService";
export default {
  data() {
    return {
      QuickBookSection: false,
      qbSelectedMovie: null,
      qbSelectedCinemas: null,
      qbSelectedDate: null,
      qbSelectedShowTime: null,
      qbSelectMovieContent: false,
      qbSelectCinemaContent: false,
      qbSelectDateContent: false,
      qbSelectShowTimeContent: false,
      selectedMovie: null,
      selectedCinema: null,
      selectedDate: null,
      selectedTime: null,
      selectMovie: false,
      selectCinema: false,
      selectDate: false,
      selectTime: false,
      movies: {},
      cinemas: {},
      dates: {},
      shows: {},
      movie_title: null,
      cinema_code: null,
      date: null,
      session: null,
      byMovie: true,
      byCinema: false,
    };
  },
  beforeMount() {
    this.QuickBook();
  },
  mounted() {
    this.$refs.selectedMovie.addEventListener(
      "blur",
      () => {
        setTimeout(() => {
          this.qbSelectMovieContent
            ? (this.qbSelectMovieContent = false)
            : undefined;
        }, 200);
      },
      true
    );
    this.$refs.selectedCinema.addEventListener(
      "blur",
      () => {
        setTimeout(() => {
          this.qbSelectCinemaContent
            ? (this.qbSelectCinemaContent = false)
            : undefined;
        }, 200);
      },
      true
    );
    this.$refs.SelectedDate.addEventListener(
      "blur",
      () => {
        setTimeout(() => {
          this.qbSelectDateContent
            ? (this.qbSelectDateContent = false)
            : undefined;
        }, 200);
      },
      true
    );
    this.$refs.SelectedShowTime.addEventListener(
      "blur",
      () => {
        setTimeout(() => {
          this.qbSelectShowTimeContent
            ? (this.qbSelectShowTimeContent = false)
            : undefined;
        }, 200);
      },
      true
    );
  },
  methods: {
    qbFilterTab(value) {
      if (value == "byMovie") {
        this.byMovie = true;
        this.byCinema = false;
      } else if (value == "byCinema") {
        this.byMovie = false;
        this.byCinema = true;
      }
      this.QuickBook();
    },
    isSelected(value) {

      console.log(value, "value >>>>>>>>>>>>>>>>>>>>>>>>> >>>>>>>>>> >>>>>>")

      if (value == "movieSelected") {
        this.selectMovie = !this.selectMovie
      } else if (value == "cinemaSelected") {
        this.selectCinema = !this.selectCinema
      } else if (value == "dateSelected") {
        this.selectDate = !this.selectDate
      } else if (value == "timeSelected") {
        this.selectTime = !this.selectTime
      }
    },
    async QuickBook(movie_title, cinema_code, date) {
      let city_id = localStorage.getItem("city_id");
      const response = await QuickBookService.QuickBook({
        movie_title,
        cinema_code,
        date,
        byCinema: this.byCinema,
        city_id : city_id
      });
      const { data } = response;
      if (data && data.status) {
        if (data.data.movieDetails) {
          this.movies = data.data.movieDetails;
        }
        if (data.data.cinemaDetails) {
          this.cinemas = data.data.cinemaDetails;
        }
        if (data.data.dateDetails) {
          this.dates = data.data.dateDetails;
        }
        if (data.data.showDetails) {
          this.shows = data.data.showDetails;
        }
      }
    },
    async handleMovieSelect(title) {
      if (this.byMovie) {
        this.cinema_code = null;
        this.qbSelectedCinemas = null;
        this.selectedCinema = null;
      }

      if (title) {
        let ccode = this.cinema_code || null;
        this.QuickBook(title, ccode);
        this.qbSelectMovieContent = false;
        this.selectMovie = false;
        this.movie_title = title;
        this.qbSelectedMovie = title;
        this.selectedMovie = title;
        this.date = null;
        this.qbSelectedDate = null;
        this.selectedDate = null;
        this.qbSelectedShowTime = null;
        this.selectedTime = null;
        this.show = null;
        this.session = null;
      }
    },
    async handleCinemaSelect(cinema_code, title) {
      if (this.byCinema) {
        this.movie_title = null;
        this.qbSelectedMovie = null;
        this.selectedMovie = null;
      }
      if (cinema_code && title) {
        this.QuickBook(this.movie_title, cinema_code);
        // this.movie_title = ;
        this.qbSelectCinemaContent = false;
        this.selectCinema = false;
        this.cinema_code = cinema_code;
        this.qbSelectedCinemas = title;
        this.selectedCinema = title;
        this.date = null;
        this.qbSelectedDate = null;
        this.selectedDate = null;
        this.qbSelectedShowTime = null;
        this.selectedTime = null;
        this.show = null;
        this.session = null;
      }
    },
    async handleDateSelect(date) {
      if (date) {
        this.QuickBook(this.movie_title, this.cinema_code, date);
        this.qbSelectDateContent = false;
        this.selectDate = false;
        this.date = date;
        this.qbSelectedDate = date;
        this.selectedDate = date;
        this.qbSelectedShowTime = null;
        this.selectedTime = null;
        this.show = null;
        this.session = null;
      }
    },
    async handleShowSelect(show_time, session) {
      if (session && show_time) {
        this.qbSelectShowTimeContent = false;
        this.selectTime = false;
        this.qbSelectedShowTime = show_time;
        this.selectedTime = show_time;
        this.show = show_time;
        this.session = session;
      }
    },
    showQuickBookSection: function () {
      this.QuickBookSection = !this.QuickBookSection;
    },
    closeQuickBookSection: function () {
      this.QuickBookSection = false;
    },
  },
};
</script>

<style>
.section-quickbook {
  width: 95%;
  padding: 15px;
  margin: 0 auto;
  max-width: 1400px;
  border-radius: 10px;
  margin-bottom: 25px;
  background: var(--bg-dark-2);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.section-quickbook input:focus {
  box-shadow: none;
  border-color: var(--rose-gold);
}

.qb-heading .qb-title {
  position: relative;
}

.qb-heading .qb-title::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -8px;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 10px solid var(--rose-gold);
}

.qb-movie,
.qb-cinema {
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
}

.qb-movie:active,
.qb-movie:hover,
.qb-movie.active,
.qb-cinema:active,
.qb-cinema:hover,
.qb-cinema.active {
  color: var(--rose-gold);
  text-decoration: underline;
}

.section-quickbook label {
  line-height: 1;
  display: block;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
  color: var(--rose-gold);
}

.quickbook-select-movie-content,
.quickbook-select-cinema-content,
.quickbook-select-date-content,
.quickbook-select-showtime-content {
  /* z-index: 1; */
  z-index: 50;
  left: 15px;
  overflow-x: auto;
  max-height: 40vh;
  column-gap: 15px;
  /* padding: 5px 15px; */
  border-radius: 5px;
  position: absolute;
  /* top: calc(100% + 5px); */
  bottom: calc(100% + 5px);
  background-color: var(--bg-dark-2);
  border: 1px solid #e0e0e0;
  color: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.qb-li-padding a{
  padding: 5px 10px 5px 10px;
}

.quickbook-select-movie-content {
  /* width: 50vw; */
  width: 100%;
  /* column-count: 3; */
}

.quickbook-select-cinema-content {
  width: 100%;
  /* column-count: 2; */
}

.quickbook-select-date-content,
.quickbook-select-showtime-content {
  column-count: 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: calc(100% - 30px);
}
.quickbook-select-movie-content ul {
  margin-bottom: 05px;
}
.quickbook-select-movie-content ul li {
  line-height: 1;
}
.quickbook-select-movie-content ul li:hover a,
.quickbook-select-cinema-content ul li:hover a,
.quickbook-select-date-content ul li:hover a,
.quickbook-select-showtime-content ul li:hover a {
  color: var(--rose-gold);
}

.quickbook-select-movie-content a,
.quickbook-select-cinema-content a {
  font-size: 14px;
  color: #fff;
  font-weight: normal;
  transition: 0.3s ease;
}

.quickbook-select-date-content a,
.quickbook-select-showtime-content a {
  display: block;
  color: #fff;
  margin: 0 0px;
  padding: 5px 10px;
}

.quickbook-select-movie-content a:hover,
.quickbook-select-cinema-content a:hover {
  color: #000;
  font-weight: 500;
}

.quickbook-select-date-content a:hover,
.quickbook-select-showtime-content a:hover {
  /* background-color: #d3d3d387; */
  color: #000;
  font-weight: 500;
}

@media (min-width: 992px) {
  .connector {
    width: 30px;
    height: 1px;
    left: -15px;
    position: absolute;
    top: calc(50% - 1px);
    background-color: #c4c4c4;
  }

  .connector::before,
  .connector::after {
    width: 5px;
    content: "";
    z-index: 3;
    height: 5px;
    position: absolute;
    border-radius: 50%;
    display: inline-block;
    background-color: #c4c4c4;
  }

  .connector::before {
    top: -2px;
    left: -1px;
  }

  .connector::after {
    top: -2px;
    right: -1px;
  }
}

.qb-mobile-tab {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  /* background-color: #fff; */
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/quickBooking.vue